import React from 'react';
import {Link} from 'react-router-dom'
import util from "../../util/tools";
import commonTools from "../../../common/util/util";
import Follow from '../follow'
import Bg from '../../../common/images/wechat.png'
import Icon from '../../../common/images/rd_1.png'
import './index.css';
import Toast from '../common/Toast'


export default class Home extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            tsBox: "",
            category:'',
            category_id:'',
            curTitle: '',
            content: '',
            contentName: '',
            background: '#ffffff',
            color: "#24211f",
            fontSize: 18,
            lastContentId: '',
            nextContentId: '',
            showBox1: false,
            showBox2: false,
            blur:false,
            step: '',//1，强制关注，2非强制，3普通
            step3:false,
            price: '999',
            lockContentId: '',//被锁章节ID
            recommendData: [],
            showFollow: false,
            imgUrl:'',
            all:0,//0,非全本，1,全本
            firstRecharge:false,//是否首充
            isShowRecharge:false,//是否显示充值
            userCoin:'',//用户的金币
            userHongBao:'',//用户的红包
            showToast:false,
            text:'',
            site:'',
            bookId: this.props.match.params.bookId,
            contentId: this.props.match.params.contentId,
            moneyLess:false,
            activeCoin: {
                is_open:0,
                total_fee:'0',
                coin: 0
            },
            newActiveCoin: {
                new_chongzhi_status: 1,//新版充值档是否开启（1标识开启，0标识未开启）
                redeploy: [
                    // {
                    //     type: 1,//支付类型1.充值送金币2.充值送会员
                    //     is_first_pay: 1,//是否首充
                    //     total_fee: 999,//充值金额（单位分）
                    //     pay_coin: 999,//（充值对应金币）
                    //     give_coin: 0,//（充值对应赠币）
                    //     first_pay_give_coin: 0,//（首充对应赠币）
                    //     remarks: "",//（标注，会员充值档可用里面的内容）
                    //     sign: 1 //（充值是传递的参数，1充值的时候传入firstpay=1，2充值的时候传入newpay=1）
                    // }
                ]
            },
            isFirst: true, // 是否是首充
            isVip: true, // 是否是vip
            isAdd: true, // 是否有赠币
            ishongbao: true // 是否是红包
        }

        this.qiangguanFun = this.qiangguanFun.bind(this);
        this.tsFun = this.tsFun.bind(this);
    }

    componentDidMount() {
        let content_id = this.props.match.params.contentId;
        let bookId = this.props.match.params.bookId;
        // 跳转阅问
        if(bookId >= 120000000 && bookId < 130000000){
            util.ajax({
                url: "/zh/additional/randomstr",
                isUser: true,
                isWechatId: true,
                method: "post",
                callback: res => {
                    if (res.result.status.code == 0) {
                        let random_str = res.result.data.random_str;
                        let _promotion_data = localStorage.getItem('_promotion_data');
                        let { channel_id,promotions_id } = JSON.parse(_promotion_data)
                        let addPath = `${channel_id!==undefined ? "&channel_id="+channel_id : ""}&${promotions_id!==undefined ? "promotions_id="+promotions_id : ""}`
                        document.location.href = `https://m.weidaoip.com/youhe/book/content/${bookId}/${content_id}?source=${document.location.host}&user_token=${util.user_token}&random_str=${random_str}${addPath}`;
                    }
                }
            });
            return false;
        }

        this.getStyle()
        this.getRecommend()
        this.getActiveCoin();
        this.getNewActiveCoin();
        let search = commonTools.searchPar()
        if (!!search.promotions_id && !!search.channel_id) {
            if(!!search.chapterid && !!search.bookid){
                localStorage.setItem('_promotion_data', JSON.stringify(search));
            }
            // 不需要获取用户阅读记录最新章节，交给接口判断
            this.getBookData(this.props.match.params.contentId||0)
        }else{
            this.getBookData(content_id)
        }
    }

    //初始状态
    getBookData(content_id) {
        let params = {
            'book_id': this.state.bookId,
            'content_id': content_id,
            'is_user_payed': 1
        }
        this.qiangguanFun(params);
    }

    checkOrder(bookId, contentId, order,route,type) {//检查order
        util.ajax({
            url: "/zh/chapter/getContentOrder",
            isUser: true,
            data: {
                'book_id': bookId,
                'content_id': contentId,
            },
            callback: res => {
                if (res.result.status.code == 0) {
                    let data = res.result.data;
                    let params = {
                        'book_id': bookId,
                        'content_id': contentId,
                    }
                    data.order = parseInt(data.order);
                    order = parseInt(order);
                    if (data.order >= order) {
                        if(type ==1){
                            this.setState({
                                showFollow: true,
                                step: 1,
                            })
                        }else if(type ==2){
                            let flag = -1;
                            let bookId = this.state.bookId;
                            let localStorage1 = JSON.parse(localStorage.getItem('_star_type_2')||"[]")
                            flag = localStorage1.findIndex((item,index)=>{
                                return item == bookId
                            })
                            if(flag < 0){
                                this.setState({
                                    showFollow: true,
                                    step:2,
                                })
                            }
                        }
                    }
                    if((data.order >= order && type == 2) || data.order<order) {
                        this.result(params,route)
                    }
                }
            }
        });
    }

    checkUserStar( params, route) {//检查用户是否关注
        let local = JSON.parse(localStorage.getItem('_imperativeattention')||"{}")
        let order = local.order;
        util.ajax({
            url: "/zh/attentionuser/one",
            isUser: true,
            isWechatId: true,
            data: {},
            callback: res => {
                if (res.result.status.code == 0) {
                    let data = res.result.data;
                    let tempData = {
                        step3:true,
                    };
                    let tempFun = ()=>{this.result(params,route)}
                    if (data.hasOwnProperty('user_id')) {
                        //已经关注过了
                        tempData.step = '';
                        tempData.step3 = false;
                        this.setState(tempData)
                    } else {
                        let type = parseInt(local.type)
                        switch (type) {
                            case 1://强制关注
                            case 2://非强制
                                tempFun = tempFun = ()=>{this.checkOrder(params.book_id, params.content_id, order,route,type)}
                                break;
                            case 3://3 普通
                                tempData.step = 3;
                                break;
                        }
                        util.ajax({
                            url: "/zh/additional/getTime",
                            data: {},
                            callback: res1 => {
                                if (res1.result.status.code == 0) {
                                    let curT = parseInt(res1.result.data.nowtime);
                                    let bl = false;
                                    if((local.showtime||[]).length <= 0){
                                        bl = true;
                                    }else{
                                        local.showtime.forEach(item=>{
                                            if(curT>=parseInt(item.startTime)&&curT<=parseInt(item.endTime)){
                                                bl = true;
                                            }
                                        });
                                    }
                                    if(bl){
                                        this.setState(tempData)
                                    }
                                }
                            }
                        });
                    }
                    tempFun();
                }
            }
        });
    }

    ChangeBack(bg,col) {
        let params = {
            fontSize:this.state.fontSize,
            color: col || "#24211f",
        }
        switch (bg){
            case '#ffffff':
                params.backgroundColor = "bg1"
                break;
            case '#e4edf0':
                params.backgroundColor = "bg2"
                break;
            case '#f0ebe4':
                params.backgroundColor = "bg3"
                break;
            case '#252525':
                params.backgroundColor = "bg4"
                break;
        }
        this.setState({
            background: bg,
            color: params.color
        },()=>{
            this.setStyle(params)
        })
    }

    changeFont(type) {
        let background=this.state.background
        let color = this.state.color
        let text = '';
        let size = parseInt(this.state.fontSize)
        let currentSize;
        if (type == 'remove') {
            currentSize = size - 2
            if (currentSize <= 10) {
                currentSize = 10;
                text = '已是最小字号';
            }
        } else if (type == 'add') {
            currentSize = size + 2
            if (currentSize >= 26) {
                currentSize = 26;
                text = '已是最大字号';
            }
        }
        this.setState({
            fontSize: currentSize
        },()=>{
            this.setStyle({
                fontSize:currentSize,
                backgroundColor:background,
                color:color
            })
        })

        if(text != ''){
            clearTimeout(this.timer1);
            this.setState({
                showToast: true,
                text: text
            },()=>{
                this.timer1 = setTimeout(()=>{
                    this.setState({
                        showToast:false,
                        text:""
                    })
                },2000)
            });
        }
    }

    qiangguanFun(params){
        let promotion = JSON.parse(localStorage.getItem('_promotion_data'))
        let local = JSON.parse(localStorage.getItem('_imperativeattention'))
        if (!!promotion && !!promotion.channel_id && !!promotion.promotions_id) {
            if (!!local && local.book_id == params.book_id && local.channel_id == promotion.channel_id && local.promotions_id == promotion.promotions_id) {
                this.setState({
                    imgUrl: local.qrcode_url
                })
                this.checkUserStar(params,1)
            } else {
                util.ajax({
                    url: "/zh/imperativeattention/one",
                    isUser: true,
                    isWechatId: true,
                    data: {
                        'book_id': params.book_id,
                        'channel_id': promotion.channel_id || 1,
                        'promotions_id': promotion.promotions_id || 1
                    },
                    callback: res => {
                        if (res.result.status.code == 0) {
                            let data = res.result.data
                            if (data.hasOwnProperty('promotions_id')) {
                                localStorage.setItem('_imperativeattention', JSON.stringify(data))
                                //修改部分
                                if (data.book_id == params.book_id) {
                                    this.setState({
                                        imgUrl: data.qrcode_url
                                    })
                                    this.checkUserStar(params,1)
                                } else {
                                    this.result(params,1)
                                }
                            } else {
                                //返回的是空数组
                                this.result(params,1)
                            }
                        }else{
                            this.result(params,1);
                        }
                    }
                });
            }
        } else {
            this.result(params,1)
        }
    }

    readBook(type) {//last 上一章 next 下一章
        this.setState({
            showBox2: false,
            isShowRecharge:false,
            blur:false,
            lastBookId:this.state.contentId,
        },()=>{
            console.log(this.state.lastBookId)
        })
        let params = {
            'book_id': this.state.bookId,
            'content_id': this.state.lastContentId,
        }
        if (type == 'next') {
            params.content_id = this.state.nextContentId;
        }
        // this.props.history.push(`/readpage/${params.book_id}/${params.content_id}`)
        window.history.replaceState({},"",document.location.origin+`/readpage/${params.book_id}/${params.content_id}`);
        this.getBookData(params.content_id);
        // this.qiangguanFun(params);
    }

    result(params,route) {
        params.is_user_payed =1
        util.ajax({
            url: "/zh/chapter/content",
            isUser: true,
            isWechatId: true,
            clearArr: ["/zh/user/getUserReadHistory"],
            data: params,
            callback: res => {
                if (res.result.status.code == 0) {//自动购买
                    let json = res.result.data
                    this.setState({
                        contentId: json.content_id
                    })
                    if(json.price > 0){
                        this.setState({
                            lockContentId: params.content_id,
                            price: res.result.data.price,
                        },()=>{
                            this.unLock();
                        })
                        return false;
                    }
                    document.title = json.book_info.book_title;
                    if (json.is_buy == 1) {//已购买
                        localStorage.setItem('read_content_id', params.content_id)
                        if(route!=1){
                            this.props.history.push(`/readpage/${params.book_id}/${params.content_id}`)
                        }
                        document.querySelector('body').scrollIntoView()
                        if(!!json.book_info.category_info.category_1.category_id){
                            this.setState({
                                category: json.book_info.category_info.category_1.short_name,
                                site:json.book_info.site,
                                category_id:json.book_info.category_info.category_1.category_id
                            })
                        }
                        this.setState({
                            content: json.content,
                            contentName: json.title,
                            lastContentId: json.last_chapter.content_id,
                            nextContentId: json.next_chapter.content_id
                        })
                    }
                }else if (res.result.status.code == 91000) {//此书需要购买后才能阅读
                    this.setState({
                        lockContentId: params.content_id,
                        price: res.result.data.price,
                        // showBox2: true, //全本充值 //之前推荐点击有这两个
                        // blur:true,
                    })
                    this.isAllBookCharge(res.result.data.price,0,true)
                }else if (res.result.status.code == 91001) {//全本购
                    const hasData = (val,label) => (val && val[label]!== undefined)
                    let allBookState = {
                        is_allbookbuy:hasData(res.result.data,"is_allbookbuy") ? res.result.data.is_allbookbuy : this.state.is_allbookbuy,
                        original_price:hasData(res.result.data,"original_price") ? res.result.data.original_price : this.state.original_price,
                    }
                    const is_allbookbuy = allBookState.is_allbookbuy!== undefined && allBookState.is_allbookbuy === 1
                    this.setState({
                        lockContentId: params.content_id,
                        price: res.result.data.price,
                        original_price:allBookState.original_price,
                        showBox2: true, //全本充值 //之前推荐点击有这两个
                        // blur:true,
                    })
                    this.checkUserMoney(res.result.data.price,1)
                }else if(res.result.status.code == 21021 || res.result.status.code == 21022){
                    // 书籍下线状态
                    this.props.history.push(`/offlineBook`)
                }else if(res.result.status.code == 70100 || res.result.status.code == 70102){
                    this.setState({
                        lockContentId: params.content_id
                    },()=>{
                        this.unLock();
                    })
                }else{
                    this.setState({
                        showToast: true,
                        text: res.result.status.msg
                    },()=>{
                        setTimeout(()=>{
                            this.setState({
                                showToast:false,
                                text:""
                            })
                        },2000)
                    });
                }
            }
        });
    }

    SaveBook() {
        this.setState({
            showBox1: true
        })
    }

    hideBox() {
        this.setState({
            showBox1: false
        })
    }

    hideBox2(e) {
        if (e.target.getAttribute('class') == 'read_cover') {
            this.setState({
                showBox2: false,
                blur:false
            })
        }
    }
    
    hideBox3(){
        let star = []
        let bookId = this.state.bookId
        star.push(bookId)
        let array = new Set(star)
        localStorage.setItem('_star_type_2',JSON.stringify(array)) //普通关注下只显示一次
        this.setState({
            showFollow: false
        })
    }

    //解锁章节
    unLock(isAllBug) {
        const vipUrl = localStorage.getItem('vipUrl')
        // 跳转到收费章节
        let data = {}
        if(isAllBug){
            data.buyallbook = 1
        }else{
            data.single_chapter_buy = 1
        }
        let addStr = `&${isAllBug ? "buyallbook=1" : "single_chapter_buy=1"}`
        util.ajax({
            url: "/zh/additional/randomstr",
            isUser: true,
            isWechatId: true,
            method: "post",
            // data:data,
            callback: res => {
                if (res.result.status.code == 0) {
                    let random_str = res.result.data.random_str;
                    document.location.href = `${vipUrl}bookv3/content/${this.state.bookId}/${this.state.lockContentId}?source=${document.location.host}&user_token=${util.user_token}&random_str=${random_str}${addStr}`;
                }
            }
        });
    }

    //是否是全本收费书籍
    isAllBookCharge(price,type,isNormalBuy){
        this.checkUserMoney(price,type,isNormalBuy)
    }

    //查询用户的金币和红包,price是书/章的价格 type //是否在全本，0，非,1 全
    checkUserMoney(price,type,isNormalBuy){
       util.ajax({
            url: "/zh/user/userInfo",
            isUser: true,
            data: {},
            callback: res => {
                if (res.result.status.code == 0) {
                    let data = res.result.data;
                    let userHongBao = data.user_money.hongbao;
                    let userCoin = data.user_money.coin;
                    this.setState({
                        userCoin,
                        userHongBao
                    })
                    //money 用户的红包加金币
                    let money = Number(userCoin)+ Number(userHongBao)
                    if(!!price){
                        if(price > money){
                            if(isNormalBuy){
                                this.isFirstChargeUser()
                            }
                            //金额不足,检查用户是否是首次充值
                            this.setState({
                                moneyLess:true
                            })
                        }
                        let bookId = this.state.bookId;
                        let isBook = JSON.parse(localStorage.getItem('_unlock') || '[]')
                        let flag = isBook.findIndex((item,index)=>{
                            return item == bookId
                        })
                        if(flag>-1){
                            //购买过
                            this.unLock()
                        }else {
                            this.setState({
                                showBox2:true ,
                                blur:true,
                                buyType:type,
                            })
                            // isBook.push(bookId)
                            // localStorage.setItem('_unlock',JSON.stringify(isBook))
                        }
                    }
                }
            }
        });
    }

    //是否是首次充值用户
    isFirstChargeUser(){
       util.ajax({
            url: "/zh/pay/lists",
            isUser: true,
            isWechatId: true,
            data: {
                __flush_cache: 1,
                page:1
            },
            callback: res => {
                if (res.result.status.code == 0) {
                    let totalNum = res.result.total_num;
                    //是首次充值用户
                    let tempData = {
                        firstRecharge:true,
                        isShowRecharge: !true,
                        blur:true
                    };
                    if(!!totalNum && totalNum>0){
                        //非首次充值用户
                    }
                    this.setState(tempData)
                }
            }
        });
    }

    getRecommend() {
        util.ajax({
            url: "/zh/book/ranking",
            isUser: true,
            isWechatId: true,
            data: {
                book_id:this.state.bookId,
                num: 4,
                page: 1,
                re_cid: 144,
            },
            callback: res => {
                if (res.result.status.code == 0) {
                    this.setState({
                        recommendData: res.result.data
                    })
                }
            }
        });
    }
    getActiveCoin(){
        util.ajax({
            url: "/zh/paymanage/info",
            isUser: true,
            data: {},
            callback: res => {
                if (res.result.status.code == 0) {
                    let data = res.result.data;
                    console.log('充值数据',data);
                    this.setState({
                        activeCoin: data
                    })
                }
            }
        });
    }
    getNewActiveCoin(){
        console.log('}}}}');
        util.ajax({
            url: "/zh/pay/redeploy",
            isUser: true,
            data: {},
            callback: res => {
                if (res.result.status.code == 0) {
                    let data = res.result.data;
                    console.log('新充值数据',data);
                    this.setState({
                        newActiveCoin: data
                    })
                }
            }
        });
    }

    goRouter() {
        this.props.history.push(`/recharge/${this.state.bookId}`)
    }

    charge(item,isfixed){
        let bookId = this.state.bookId;
        let url = `${document.location.href}/recharge`
        let params = {
            'total_fee':isfixed ? item : item*10*10,
            'back_url':url,
            'error_url':url,
            type:3,
        }
        if(isfixed == 1){
            params.firstpay = 1;
        }
        if(isfixed == 2){
            params.newpay = 1;
        }
        console.log('8888',params);
        if(!!bookId){
            params.book_id = bookId
        }
        util.ajax({
            url: "/zh/pay/wgpay",
            method:'post',
            isUser: true,
            isWechatId: true,
            data: params,
            callback: res => {
                if (res.result.status.code == 0) {
                    document.location.href = res.result.data.url
                }else {
                    this.setState({
                        showToast:true
                    })
                    this.timer = setTimeout(()=>{
                        this.setState({
                            showToast:false,
                            text:res.result.status.msg
                        })
                    },2000)
                }
            }
        });
    }

    setStyle(params){
        util.ajax({
            url: "/zh/additional/setStyle",
            method:'POST',
            isUser: true,
            isWechatId: true,
            data: {
                read_style:JSON.stringify(params)
            }
        });
    }

    getStyle(){
        util.ajax({
            url: "/zh/additional/getStyle",
            isUser: true,
            isWechatId: true,
            data: {},
            callback: res => {
                if (res.result.status.code == 0) {
                    let style = JSON.parse(res.result.data.read_style);
                    if(!!style){
                        let tempData = {};
                        if(!!style.fontSize){
                            tempData.fontSize = style.fontSize;
                        }
                        if(!!style.backgroundColor){
                            let background = style.backgroundColor
                            let bg =background
                            if(background == 'bg1'){
                                bg = '#ffffff'
                            }else if(background == 'bg2'){
                                bg = '#e4edf0'
                            }else if(background == 'bg3'){
                                bg='#f0ebe4'
                            }else if(background == 'bg4'){
                                bg='#252525'
                            }
                            tempData.background = bg;
                        }
                        if(!!style.color){
                            tempData.color = style.color
                        }
                        this.setState(tempData)
                    }
                }
            }
        });
    }

    tsFun(){
        this.setState({
            tsBox: !this.state.tsBox
        });
    }

    giveUpBuyAll = () => {
        let bookId = this.state.bookId;
        let isBook = JSON.parse(localStorage.getItem('_unlock') || '[]')
        let flag = isBook.findIndex((item,index)=>{
            return item == bookId
        })
        if(flag>-1){

        }else{
            isBook.push(bookId)
            localStorage.setItem('_unlock',JSON.stringify(isBook))
        }
    }

    modalBuy = (type) => {
        this.setState({
            all:type ? 1 : 0
        })

        if(!type){
            //单章购买即放弃全本购买
            this.giveUpBuyAll()
        }

        if(this.state.moneyLess){
            this.isFirstChargeUser()
        }else{
            this.unLock(type);
        }
    }

    back = (e) => {
        if(e.target.classList.value === "read_cover"){
            if(this.state.lastBookId){
                this.setState({
                    showBox2: false,
                    isShowRecharge:false,
                    blur:false,
                    firstRecharge:false,
                })
                window.history.replaceState({},"",document.location.origin+`/readpage/${this.state.bookId}/${this.state.lastBookId}`);
                this.getBookData(this.state.content_id);
            }else{
                this.props.history.goBack();
            }
            // this.props.history.push(`/catalogue/${this.state.bookId}`)
        }
    }

    // 生产随机码
    handleAuthRandom() {
        util.ajax({
            url: '/zh/genuineverify/randomCode',
            isUser: true,
            isWechatId: true,
            method: 'post',
            data: {
                book_id: this.state.bookId,
                content_id: this.state.contentId,
                domain_url: window.location.hostname
            },
            callback: res => {
                if (res.result.status.code === 0) {
                    const { code } = res.result.data
                    window.location.href = `https://check.youhezhuoyi.com/genuinecheck/auth/index?code=${code}`
                }
            }
        })
    }

    render() {
        let bookId = this.state.bookId;
        var isNew = this.state.newActiveCoin.new_chongzhi_status;
        var newData = this.state.newActiveCoin.redeploy;
        return (
            [
                <div className='read' style={{background: this.state.background,color: this.state.color}} key='1'>
                    {/*{*/}
                        {/*!!this.state.tsBox &&*/}
                        {/*<div className="tsDialogBox" onClick={this.tsFun}><Link to={`/tsPage/${bookId}/${this.state.contentId}`} className='yesOrNoBtn'>同意或不同意</Link></div>*/}
                    {/*}*/}
                    <div className={`${this.state.blur ? 'blur' : ''}`}>
                        <div className='read_header' style={this.state.color != "#24211f" ? {borderColor: "#3b3a3a",color: "#736e67"} : {}}>
                            <Link to='/' className='read_header_single'>首页</Link>
                            <Link to='/recentlyread' className='read_header_single'>阅读历史</Link>
                            <Link to="/recharge" className='read_header_single'>充值</Link>
                            <Link to={`/category?category_id=${this.state.category_id}&site=${this.state.site}`} className='read_header_single'>更多{this.state.category}</Link>
                            {/*<div onClick={this.tsFun} to='/feedback' className='read_header_tousu'>投诉</div>*/}
                        </div>
                        <div className='read_series'>
                            <div className={`read_series_single ${this.state.background == "#ffffff" ? "active": ""}`} onClick={() => this.ChangeBack('#ffffff')}></div>
                            <div className={`read_series_single ${this.state.background == "#e4edf0" ? "active": ""}`} onClick={() => this.ChangeBack('#e4edf0')}></div>
                            <div className={`read_series_single ${this.state.background == "#f0ebe4" ? "active": ""}`} onClick={() => this.ChangeBack('#f0ebe4')}></div>
                            {
                                this.state.background == "#252525" ?
                                <div className={`read_series_single bg2 ${this.state.background == "#252525" ? "active": ""}`} onClick={() => this.ChangeBack('#ffffff')}></div>
                                :
                                <div className={`read_series_single ${this.state.background == "#252525" ? "active": ""}`} onClick={() => this.ChangeBack('#252525','#736e67')}></div>
                            }
                            <div className={`read_series_single`} onClick={() => this.changeFont('remove')}>A -</div>
                            <div className={`read_series_single`} onClick={() => this.changeFont('add')}>A +</div>
                        </div>
                        <div className='read_cont' style={{fontSize: `${this.state.fontSize}px`}}>
                            <span className='read_cont_title'>{this.state.contentName}</span>
                            <div className='read_cont_font' dangerouslySetInnerHTML={{__html: this.state.content}}>
                            </div>
                        </div>
                        <a className='read_follow' onClick={() => this.SaveBook()}>点击此处，收藏本书</a>
                        <div className="auth-button" onClick={() => this.handleAuthRandom()}>
                            <img src={require('./imgs/auth.png')} alt="auth"/>
                        </div>
                        {
                            this.state.step3 && 
                                <div className='promotion_wrapper'>
                                    <span className='left'>
                                        <img src={this.state.imgUrl} className='img_url'/>
                                    </span>
                                    <div className='right'>
                                        <p className='p1'>长按左侧二维码3秒关注公众号</p>
                                        <p className='p2'>方便下次继续阅读，还可以每日签到领金币哦</p>
                                    </div>
                                </div>
                        }
                        <div className={`read_select ${this.state.color != "#24211f" ? "col" : ""}`}>
                            <span className='read_select_single' onClick={() => this.readBook('last')}>上一章</span>
                            <Link className='read_select_single' to={`/catalogue/${bookId}`}><span>目录</span></Link>
                            <span className='read_select_single' onClick={() => this.readBook('next')}>下一章</span>
                        </div>
                        {
                            !!this.state.recommendData && this.state.recommendData.length > 0 &&
                                <div className='read_recommend'>
                                    <div className='title'>
                                        <div className='title_line'></div>
                                        <span className='title_font'>作者推荐</span>
                                    </div>
                                    <div className='read_recommend_list'>
                                        {
                                            this.state.recommendData.map((item, index) => {
                                                return (
                                                    <div className='read_recommend_list_single' key={`r_${index}`}
                                                         onClick={() => this.result({'book_id': item.book_id,'content_id': 0})}>{item.book_intro}</div>
                                                )
                                            })
                                        }
                                    </div>
                                </div>
                        }
                    </div>
                    {//全本书充值
                        this.state.showBox2 && this.state.buyType === 1 &&
                            <div className='read_cover' onClick={this.back}>
                                <div className='read_cover_bot'>
                                    <div className='read_cover_bot_zhichi'>
                                        <span className='read_cover_bot_zhichi_jiesuo-buy-all'>每日全本购</span>
                                    </div>
                                    <div className='read_cover_bot_coin-buy-all' style={{marginLeft:"0.34rem"}}>本书价格：<span
                                        style={{color: '#ED6460',fontSize:'0.38rem'}}>{this.state.price}</span>金币
                                        <span style={{
                                            color:"rgba(138,136,134,1)",marginLeft:"0.62rem",display: "inline-block",
                                            backgroundImage: "url(data:image/gif;base64,R0lGODlhAQABAJEAAAAAAP///5mZmf///yH5BAEAAAMALAAAAAABAAEAAAICVAEAOw==)",
                                            backgroundRepeat: "repeat-x",backgroundPosition: "left center",top:"0.02rem",
                                            height:" .32rem",lineHeight: ".40rem",
                                        }}>
                                            {`原价${this.state.original_price || 0}金币`}
                                        </span>
                                    </div>
                                    <div className='read_cover_bot_coin-buy-all' style={{marginLeft:"0.34rem"}}>金币余额：<span
                                        >{this.state.userCoin || 0}</span>金币
                                    </div>
                                    <div className='read_cover_bot_coin-buy-all' style={{marginLeft:"0.34rem"}}>红包余额：<span
                                        >{this.state.userHongBao || 0}</span>金币
                                    </div>
                                    <div className='read_cover_bot_btn-buy-all' onClick={() => this.modalBuy(true)}>全本购买</div>
                                    <span className='read_cover_bot_span-buy-all' onClick={ ()=>this.modalBuy() }>继续单章阅读</span>

                                    {/* <div className='read_cover_bot_crown'>
                                        <img className='read_cover_bot_crown_pic'
                                             src={require('../../../common/images/crown.png')} alt=""/>
                                        <div className='read_cover_bot_crown_box'
                                             onClick={() => this.goRouter()}>开通VIP，全站15万本小说免费看1年（含本书）
                                        </div>
                                    </div> */}
                                    <div className='read_cover_bot_tips' style={{marginLeft:"0.34rem"}}>*虚拟商品购买后不可退换</div>
                                </div>
                            </div>
                    }
                    {//解锁本章
                        this.state.showBox2 && this.state.buyType === 0 &&
                        <div className='read_cover' onClick={this.back}>
                            <div className='read_cover_bot'>
                                <div className='read_cover_bot_zhichi'>
                                    <img className='read_cover_bot_zhichi_arrow'
                                         src={require('../../../common/images/arrow_r.png')}
                                         alt=""/>
                                    <span className='read_cover_bot_zhichi_up' onClick={() => this.readBook('last')}>上一章</span>
                                    <span className='read_cover_bot_zhichi_jiesuo'>支持作者创作，解锁后继续阅读</span>
                                </div>
                                <span className='read_cover_bot_zhichi_tips'>*已解锁的章节不会重复解锁</span>
                                <div className='read_cover_bot_coin'>解锁本章：<span
                                    style={{color: '#ED6460'}}>{this.state.price}</span>金币
                                </div>
                                <div className='read_cover_bot_btn' onClick={ ()=>this.unLock() }>立即解锁</div>

                                {/* <div className='read_cover_bot_crown'>
                                        <img className='read_cover_bot_crown_pic'
                                             src={require('../../../common/images/crown.png')} alt=""/>
                                        <div className='read_cover_bot_crown_box'
                                             onClick={() => this.goRouter()}>开通VIP，全站15万本小说免费看1年（含本书）
                                        </div>
                                    </div> */}
                                <div className='read_cover_bot_tips'>*虚拟商品购买后不可退换</div>
                            </div>
                        </div>
                    }
                    {//章节充值
                        this.state.firstRecharge &&
                            <div className='read_cover' onClick={this.back}>
                                <div style={{height:'auto',maxHeight: '11.2rem',overflow:'auto'}} className='read_cover_bot read_rg_wrapper'>
                                    <div className='read_cover_bot_zhichi'>
                                        {/*<img className='read_cover_bot_zhichi_arrow'*/}
                                             {/*src={require('../../../common/images/arrow_r.png')}/>*/}
                                        {/*<span className='read_cover_bot_zhichi_up' onClick={() => this.readBook('last')}>上一章</span>*/}
                                        <span className='read_cover_bot_zhichi_jiesuo'>支持作者创作，解锁后继续阅读</span>
                                    </div>
                                    <p className='read_cover_bot_coin'>解锁{this.state.all==0?'本章':'全本'}：<span
                                        style={{color: '#ED6460'}}>{this.state.price}</span>金币
                                    </p>
                                    <p className='read_user_money' >金币余额：<span style={{color: '#ED6460'}}>{this.state.userCoin}</span>金币 <span style={{marginLeft:'0.3rem'}}>红包余额：</span><span style={{color: '#ED6460'}}>{this.state.userHongBao || 0}红包</span>
                                    </p>
                                    <p className='read_rg_desc'><span className='pl'>金币不足，请充值</span>{/* <Link to={`/recharge/${bookId}`} className='pr'>更多充值及说明 >></Link> */}</p>
                                    <div>

                                    </div>
                                    <div className='read_rg_content'>
                                        <a style={{display: ((this.state.activeCoin.is_open == 1)&&!(isNew == 1)) ? 'block' : 'none'}} className='read_rg_item newBox' onClick={()=>this.charge(this.state.activeCoin.total_fee,1)}>
                                            <div className="newBox_top">得{this.state.activeCoin.coin}金币</div>
                                            <div className="newBox_middle">
                                                <span>{this.state.activeCoin.coin}金币</span>
                                                {/*<img src={require('../../../common/images/addhb.png')} alt=""/>*/}
                                                {/*<span className="subCoin">10010</span>*/}
                                            </div>
                                            <div className="newBox_bottom">￥{(Number(this.state.activeCoin.total_fee)/100).toFixed(2)}</div>
                                            {/*<img  src={require(`../../../common/images/1_1.png`)} />*/}
                                        </a>
                                        {/*首冲*/}
                                        {
                                            isNew == 1&&newData.map((item,index)=>{
                                                return <a key={index} style={{display: 'block'}} className={item.type == 2  ? 'block newBox vipcharge' : item.type == 1&&item.is_first_pay == 1 ? 'block newBox firstCharge' : 'block newBox'} onClick={()=>this.charge(item.total_fee,item.sign)}>
                                                    <div style={{color: item.type == 2 ? 'rgba(121, 81, 0, 1)' : '#333'}} className="newBox_top">
                                                        {
                                                            item.type == 2 ? '包年VIP' :  '得' + (item.pay_coin + (item.is_first_pay == 1 ? item.first_pay_give_coin : item.give_coin)) + '金币'
                                                        }
                                                    </div>
                                                    <div style={{color: item.type == 2 ? 'rgba(121, 81, 0, 1)' : '#333'}} className="newBox_middle">
                                                        <span>{item.type == 2 ? item.remarks : item.pay_coin + '金币'}</span>
                                                        {
                                                            ((item.first_pay_give_coin !== 0||item.give_coin !== 0))&&<span className="subCoin isSubadd" style={{color: 'rgba(237,100,96,1)'}}>
                                                            {
                                                                item.is_first_pay == 1 ? item.first_pay_give_coin : item.give_coin
                                                            }金币
                                                        </span>
                                                        }
                                                    </div>
                                                    <div style={{color: item.type == 2 ? 'rgba(121, 81, 0, 1)' : '#333'}} className="newBox_bottom">
                                                        <span className="valid" style={{color: item.type == 2 ? 'rgba(121, 81, 0, 1)' : 'rgba(237,100,96,1)'}}>
                                                            ￥{(Number(item.total_fee)/100).toFixed(2)}
                                                        </span>
                                                        {
                                                            item.is_first_pay == 1&&item.sign == 2&&
                                                            <span className="notvalid">
                                                                ￥{(Number(item.total_fee)*2/100).toFixed(2)}
                                                            </span>
                                                        }
                                                    </div>
                                                    {/*<img  src={require(`../../../common/images/1_1.png`)} />*/}
                                                </a>
                                            })
                                        }
                                        {
                                            !isNew&&<a className='read_rg_item' onClick={()=>this.charge(29.9)}><img src={require('../../../common/images/1_1.png')}/></a>
                                        }
                                        {
                                            !isNew&&<a className='read_rg_item' onClick={()=>this.charge(49.9)}><img src={require('../../../common/images/2_1.png')}/></a >

                                        }
                                        {
                                            !isNew&&<a className='read_rg_item' onClick={()=>this.charge(99.9)}><img src={require('../../../common/images/3_1.png')}/></a>
                                        }
                                        {
                                            !isNew&&this.state.activeCoin.is_open == '0'&&<a className='read_rg_item' onClick={()=>this.charge(199.9)}><img src={require('../../../common/images/4_1.png')}/></a>

                                        }
                                    </div>
                                    <div className='read_cover_bot_tips'>*虚拟商品购买后不可退换</div>
                                </div>
                            </div>
                    }
                    {
                        this.state.showBox1 &&
                            <div className='rd_dialog' onClick={() => this.hideBox()}>
                                <div className='rd_d_top'><img src={Icon} alt=""/></div>
                                <div className='rd_d_btm'><img src={Bg} style={{width: '100%', float: 'left'}}/></div>
                                <div className='close'>取消</div>
                            </div>
                    }
                </div>,
                this.state.showFollow && <Follow key='2' step={this.state.step} hideBox={()=>this.hideBox3()} imgUrl = {this.state.imgUrl}/>,
                <Toast text={this.state.text} key='3'/>
            ]
        );
    }
}